import http from '@/http'
const URL = '/admin/custom-lists'

export const list = (params) => {
  return http.get(URL, { params: params })
}

export const show = (id) => {
  return http.get(URL + `/${id}`)
}

export const save = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const destroy = (id) => http.delete(URL + `/${id}`)

// Items
export const getItems = (listId, params) => {
  return http.get(URL + `/${listId}/items`, { params: params })
}

export const saveItem = (listId, payload) => {
  if (payload.id) {
    return http.put(URL + `/${listId}/items/${payload.id}`, payload)
  }
  return http.post(URL + `/${listId}/items`, payload)
}

export const destroyItem = (listId, itemId) => {
  return http.delete(URL + `/${listId}/items/${itemId}`)
}

// Import
export const importItems = (listId, formData) => {
  return http.post(URL + `/${listId}/import`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export default {
  list,
  show,
  save,
  destroy,
  getItems,
  saveItem,
  destroyItem,
  importItems
}
